import React, { useEffect, useRef } from 'react';
import '../styles/Voyage.css';

const VoyagePage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          if (target.tagName === 'H2') {
            target.classList.add('bounce-in');
          } else if (target.tagName === 'P') {
            const index = Array.from(target.parentElement.children).indexOf(target) - 1; // Adjust for h2
            if (index % 2 === 0) {
              target.classList.add('slide-left');
            } else {
              target.classList.add('slide-right');
            }
          } else if (target.classList.contains('timeline-item')) {
            const index = Array.from(target.parentElement.children).indexOf(target);
            if (index % 2 === 0) {
              target.classList.add('fade-in');
            } else {
              target.classList.add('zoom-in');
            }
            observer.unobserve(target);
          }
        }
      });
    }, { threshold: 0.3 });

    const elements = sectionRef.current.querySelectorAll('h2, p, .timeline-item');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="voyage-container">
      <section id="voyage" ref={sectionRef}>
        <h2>Our Voyage</h2>
        <p>
          Dr. BhuPat Pharma Pvt Ltd embarked on its transformative journey on <span className="highlight">19th February 2024</span>, 
          registering as a company dedicated to revolutionizing the gynecological sector. Starting in Maharashtra, 
          we set out to leave a lasting footprint with <span className="highlight">top-quality products</span> and unparalleled service.
        </p>
        <p>
          Today, our family comprises <span className="highlight">24 passionate members</span>, each contributing to our mission 
          of empowering women's health. We're not just a company—we're a movement, blending science, innovation, 
          and care to transform lives across India and beyond.
        </p>
        <p>
          Our voyage is just beginning. With ambitious plans to expand nationwide, we're committed to building 
          <span className="highlight">strong relationships</span> with healthcare professionals, patients, and communities, 
          ensuring every woman has access to the care she deserves.
        </p>

        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-content">
              <h3>February 2024 - The Beginning</h3>
              <p>Registered Dr. BhuPat Pharma Pvt Ltd in Chh. Sambhajinagar, launching our focus on gynecological care.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-content">
              <h3>March 2024 - First Steps</h3>
              <p>Established a strong presence in Maharashtra with our initial team of dedicated professionals.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-content">
              <h3>June 2024 - Growth Milestone</h3>
              <p>Grew to 24 team members, expanding our reach and impact in women's healthcare.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-content">
              <h3>Future - Nationwide Vision</h3>
              <p>Planning to scale across India, bringing innovative gynecare solutions to every region.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VoyagePage;